import type { GameMeta } from '@gmp/game-sdk';

export const lavaRisingMeta = {
  id: 'lava-rising',
  name: 'Lava Rising',
  tagline: 'Scramble up the Collapsing Quarry before the lava catches you.',
  description:
    'The lava never stops rising, and it keeps getting faster; after a few minutes it surges in sudden death. Jump, climb ladders, ride lifts and shove rivals off ledges as the whole pack fights its way up a towering quarry. Three rounds by default, each on a different map: the Collapsing Quarry, Switchback Cliffs, Crumbling Caves or Stepping Stones. Grab gems on the way for extra points. Last climber standing wins.',
  minPlayers: 2,
  maxPlayers: 8,
  estimatedMinutes: [6, 10],
  usesMedia: false,
  modes: [
    { id: 'survival', name: 'Survival', description: 'Touch the lava and you are out. Last climber standing wins the round; three rounds on different maps; gems add extra points.' },
    { id: 'casual', name: 'Casual', description: 'Quick respawns for two minutes of climbing. Collect the most gems.' },
  ],
  theme: { primary: '#ff6a00', secondary: '#7cf2ff', background: '#1a0d08', ink: '#fff1e6' },
  readiness: 'beta',
  genre: 'Climb and survive',
  controls: 'touch-action',
  category: 'versus',
  instructions: [
    { icon: 'Siren', title: 'Keep climbing', body: 'The lava rises the whole time and speeds up as it goes. Stop climbing and it catches you; there is rarely a reason to go down. There is no top to reach: after a few minutes the lava surges (sudden death) until one climber is left.' },
    { icon: 'Hand', title: 'Move and jump', body: 'Stick to run and climb ladders. Hold Jump longer to jump higher; jump against a quarry wall to kick off it. Hold down to drop through a ledge.' },
    { icon: 'Zap', title: 'Shove or dash', body: 'Shoves a rival next to you, otherwise dashes. Hold it to wind up a bigger shove. It costs stamina.' },
    { icon: 'Sparkles', title: 'Hazards', body: 'Cracked ledges crumble soon after you land on them. Bubbling lava means a geyser is about to spout.' },
    { icon: 'Trophy', title: 'Survive, grab gems', body: 'Last climber standing wins the round. Glowing pink gems just above the pack are worth 10 extra points each.' },
  ],
} satisfies GameMeta;
